import {IEntity} from "../../../typescript-plugin/entities/IEntity";
import {Key} from "../../../typescript-plugin/entities/Key";
import {IdKey} from "../../../typescript-plugin/entities/IdKey";

export class Occasion implements IEntity{
    id:string;
    name:string;
    link:string;
    picture:string;
    price:number;
    gearbox:Gearbox;
    gasoline:Gasoline;
    date:Date;
    mileage:number;
    brand:Brand;

    getBrandAsString(){
        return Brand[this.brand].replace("_", " ");
    }

    getGearboxAsString(){
        return Gearbox[this.gearbox];
    }

    getGasolineAsString(){
        return Gasoline[this.gasoline];
    }

    public Key(): Key {
        return new IdKey(this.id);
    }

    public ToPersistable(): {} {
        return this.Serialize();
    }

    public ToEntity(data: {}): void {
        return this.Deserialize(data);
    }

    public Serialize(): {} {
        return {
            id: this.id,
            name: this.name,
            link: this.link,
            picture: this.picture,
            price: this.price,
            gearbox: this.gearbox,
            gasoline: this.gasoline,
            date: this.date == null ? undefined : this.date.getTime(),
            mileage: this.mileage,
            brand: this.brand,
        };
    }

    public Deserialize(data: {}): void {
        this.id = data["id"];
        this.name = data["name"];
        this.link = data["link"];
        this.picture = data["picture"];
        this.price = data["price"];
        this.gearbox = data["gearbox"];
        this.gasoline = data["gasoline"];
        this.mileage = data["mileage"];
        this.brand = data["brand"];

        this.date = new Date();
        this.date.setTime(data["date"]);
    }

    public AsFake(): Occasion{
        this.brand = Math.floor(Math.random() * 5);
        this.name = this.getBrandAsString();
        this.date = new Date();
        this.price = Math.floor(Math.random() * 10000);
        this.mileage = Math.floor(Math.random() * 50000);
        this.gasoline = Math.floor(Math.random() * 2);
        this.gearbox = Math.floor(Math.random() * 2);
        this.link = "http://www.luxauto.lu/fr/occasion/?id=900377";
        this.picture = "http://localhost:4200/assets/img/car-sample.jpg";
        return this;
    }
}

export enum Gearbox{
    Manuel,
    Automatique
}

export enum Gasoline{
    Essence,
    Diesel
}

export enum Brand {
    Audi,
    BMW,
    Volkswagen,
    Mercedes,
    Land_Rover,
    Renault,
    Suzuki,
    Ford,
    Peugeot,
    Volvo,
    Opel,
    Toyota,
    Jeep,
    Nissan,
    Hyundai,
    Fiat,
    Mini,
    Dacia,
    Alpine,
    Skoda,
    Kia,
    Citroen,
    Seat,
    Autre
}


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/server/src/base/entities/occasion/Occasion.ts